import './heading.scss'

const Heading = ({ children }: any) => {
  return (
    <div className="heading">
      <h5 className="m-0">{children}</h5>
    </div>
  )
}

export default Heading
